<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.paypwdtitle')">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="wrapper">
        <div class="item">
            <p class="title">{{$t('setting.paypwd')}}</p>
            <van-password-input
                :value="opw"
                :length="6"
                :gutter="10"
                :focused="oshowKeyboard"
                @focus="oshowKeyboard = true;tshowKeyboard = false;"
            />
            <van-number-keyboard
                v-model="opw"
                :show="oshowKeyboard"
                @input ="opw.length !== 5 ? oshowKeyboard = true  : tshowKeyboard=true;"
                @blur="oshowKeyboard = false"
            />
        </div>
        <div class="item">
        <p class="title">{{$t('setting.repaypwd')}}</p>
        <van-password-input
            :value="tpw"
            :length="6"
            :gutter="10"
            :focused="tshowKeyboard"
            @focus="tshowKeyboard = true;oshowKeyboard=false;"
        />
        <van-number-keyboard
            v-model="tpw"
            :show="tshowKeyboard"
            @input ="tpw.length !== 5 ? tshowKeyboard = true  : tshowKeyboard = false;oshowKeyboard=false"
            @blur="tshowKeyboard = false"
        />
      </div>
        <van-button class="sub-btn" type="default" @click="setPayPassword()">{{$t('setting.confirm')}}</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      opw: '',
      tpw: '',
      oshowKeyboard: true,
      tshowKeyboard: false,
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    setPayPassword() {
      this.oshowKeyboard = false;
      this.tshowKeyboard = false;
      if(this.opw.length !== 6){
        this.oshowKeyboard = true;
        this.$toast(this.$t('setting.plseall'));
        return false;
      }
      if(this.tpw.length !== 6){
        this.tshowKeyboard = true;
        this.$toast(this.$t('setting.plseall'));
        return false;
      }
      if(this.opw !== this.tpw){
        this.$toast(this.$t('setting.pswwrong'));
        return false;
      }else {
        this.$http({
          method: 'post',
          data:{paypassword:this.opw},
          url: 'user_set_paypw'
        }).then(res=>{
          if(res.code === 200){
            setTimeout(() => {
              this.$toast(res.msg);
            }, 500);
              this.$router.push("Mine")
          }else if(res.code ===401){
            this.$toast(res.msg);
          }
        })
      }
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.radio = res.data.sex;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container{
	max-width: 500PX;
}
.van-nav-bar {
    z-index: 999;
    position: relative;
    background: linear-gradient(20deg, #3498db, #8e44ad) no-repeat 50%/100%;
}
.van-nav-bar__content{
	height:3rem;
}
.container .wrapper{
  height: 100%;
  //overflow-y: auto;
  background-color: #fff;
  //-webkit-overflow-scrolling: touch;
}
.container .wrapper .item .title{
  margin: 1.5rem 0;
  line-height: 1rem;
  font-size: 1rem;
  font-weight: 500;
  color: #000;
  text-align: center;
}
::v-deep .van-password-input{
  width: 80%;
  height: 4rem;
  margin: 0 auto;

}
::v-deep .van-password-input__security li {
  font-size: 1rem;
  line-height: 30;
  background-color: #ebedf0;
}
::v-deep .van-password-input__security {
  height: 3rem;
}
::v-deep .van-password-input .van-password-input__security .van-password-input__item {
  height: 100%;
  border: 0;
  text-align: center;
  border-radius: 1rem;
}
.van-password-input__security i {
  width: 1.3rem;
  height: 1.3rem;
}
::v-deep .van-key {
  height: 4.5rem;
  font-size: 2rem;
  line-height: 2rem;
  border-radius: 0.5rem;
}
::v-deep .van-number-keyboard {
  z-index:100;
  width: 100%;
  padding-bottom: 1rem;
  background-color: #f2f3f5;
}
::v-deep .van-key__collapse-icon {
   width: 2rem;
   height: 2rem;
 }
::v-deep .van-key__delete-icon {
  width: 2rem;
  height: 2rem;
}
.container .wrapper .sub-btn{
  margin: 2rem 2rem 2rem 2rem;
  height: 3rem;
  width: 80%;
  font-size: 1.3rem;
  border-radius: 0.5rem;
  color: #fff;
  background: linear-gradient(20deg, #3498db, #8e44ad);
}
</style>